import { MasterMessage } from '../../../masters/masterMessages';
import { ToastSwal } from '../general/toastSwal/toastSwal';

export const getUserLocation = async (): Promise<[number, number]> => {
    const { messageGeolocalizationError } = MasterMessage.auth.login;

    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            ({ coords }) => {
                resolve([coords.longitude, coords.latitude]);
            },
            (error) => {
                ToastSwal.fire({
                    text: messageGeolocalizationError,
                    icon: 'error',
                    iconColor: '#1d1d1d',
                });
                console.log(error);
                reject();
            }
        );
    });
};
